import { MediaData } from 'components/MediaViewer'
import { AppPreviewActions } from '.'
import { InterpolationListProps } from '..'

export interface UpdateVideoCreationStep1Data {
    taskTitle?: string
    stepTitle?: string
    title?: string
    videoDos?: string
    videoDonts?: string
    videoTextOverlayDos?: string
    videoTextOverlayDonts?: string
    exampleVideo?: MediaData[]
}

interface UpdateVideoCreationInterpolationListData {
    videoDos: InterpolationListProps
    videoTextOverlayDos: InterpolationListProps
}

export const updateVideoCreationStep1Data = (payload: UpdateVideoCreationStep1Data) => ({
    payload,
    type: AppPreviewActions.UPDATE_VIDEO_CREATION_STEP1_DATA,
})

export const updateVideoCreationInterpolationListData = (payload: UpdateVideoCreationInterpolationListData) => ({
    payload,
    type: AppPreviewActions.UPDATE_VIDEO_CREATION_PLACEHOLDER_DATA,
})
